import React from "react";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import { CommonCss } from "../services/CommonCss";
import Help from "@material-ui/icons/Help";
import Button from '@mui/material/Button';

const useStyles = makeStyles((theme) => ({
  fs21: {
    fontSize: "21px",
  },
  fs32: {
    fontSize: "32px",
  },
}));

function BreadcrumbPage(props) {
  const commonClasses = CommonCss();
  const history = useHistory();
  const classes = useStyles();
  const { rows, title,icon} = props;
  const handleChange = () => {
    //
    props.onChange();
  }

  return (
    <div>
      <Box bgcolor="#1A1A31" px={2.5} borderRadius={10}>
        <Box display="flex" className={commonClasses.justifyContentBetween}>
          <Box>
            <Box display="flex" alignItems="center">
              {rows.length
                ? rows.map((row, index) => (
                  <Box display="inline" key={"Breadcrumb" + index}>
                    {rows.length - 1 != index ? (
                      <Box display="flex" className="breadcrumnav" alignItems="center">
                        <Box
                          component="a"
                          className={classes.fs21}
                          href="javascript:void(0)"
                          color="#ffffff !important"
                          onClick={() => {
                            history.push(row.url);
                          }}
                          py={1}
                        >
                          {row.name}
                        </Box>
                        <Box component="span" color="#FFF8F8" px={1}>
                          <Box display="flex" className="breadcrumbarrow" alignItems="center">
                            <NavigateNextIcon className={classes.fs32} />
                          </Box>
                        </Box>
                      </Box>
                    ) : (
                      <Box display="flex" className="breadcrumnav" alignItems="center">
                        <Box
                          component="span"
                          color="#FFF8F8"
                          className={clsx(classes.fs21)}
                          letterSpacing={0.63}
                          py={1}
                        >
                          {row.name}
                         
                        </Box>
                      </Box>
                      )}
                 
                   {/* <Button onClick={() => handleChange()} ><Help /></Button>*/}
                    {/* onChange={(event, newValue) => handleChange(event, newValue)} */}
                  </Box>
                ))
                : ""}
            </Box>
          </Box>
          <Box color="#FF4717" fontWeight="600" fontSize={35}>
            {title ? title : ""}
          </Box>
          <Box component="div" className="pos_relative">
                <Box component="div" className="help_blk3">
                      <Button style={{color:"#ff4717"}}>{icon}</Button> 
                        </Box>
                        </Box>
        </Box>{" "}
      </Box>
    </div>
  );
}

BreadcrumbPage.propTypes = {};

export default BreadcrumbPage;
